module.exports = __webpack_public_path__ + "static/media/bg-logo.5ac88a20.jpg";